module.exports = __webpack_public_path__ + "img/file_upload_icon.6b3b6884.png";